export default 'analytics';
